var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MdWarning, MdDelete } from 'react-icons/md';
import { Flex, Text } from "./..";
import { useTheme } from "../../hooks";
export var DialogIconWrapper = function (props) { return (React.createElement(Text, __assign({}, props, { lss: __assign({ textScale: 'heading1', color: 'primary500', my: 'md', display: 'block', textAlign: 'center', lineHeight: 1 }, props.lss) }))); };
export var DialogAlertIcon = function () { return (React.createElement(DialogIconWrapper, { lss: {
        color: 'warning500'
    } },
    React.createElement(MdWarning, null))); };
export var DialogDeleteIcon = function () {
    var theme = useTheme();
    return (React.createElement(DialogIconWrapper, { lss: {
            color: 'primary500',
            textScale: 'heading3'
        } },
        React.createElement(Flex, { lss: {
                my: 0,
                mx: 'auto',
                bg: 'gray200',
                width: theme.space.xxxl,
                height: theme.space.xxxl,
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 'rounded'
            } },
            React.createElement(MdDelete, null))));
};
//# sourceMappingURL=DialogIcons.js.map